import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { produce } from 'immer';
import noop from 'lodash/noop';
import moment from 'moment-timezone';
import { useCallback } from 'react';
import { useMigrateOpeningHoursContext } from 'components/powerFlowShared/components/modals/migrateOpeningHours/migrateOpeningHours.context';
import { OpeningHours } from 'components/settings/components/sections/openingHours/views/schedule/components/scheduleItem/components/listItem/components/openingHours/openingHours';
import { ListItemContext } from 'components/settings/components/sections/openingHours/views/schedule/components/scheduleItem/components/listItem/listItem.context';
import { validateIntervals } from 'components/settings/components/sections/openingHours/views/schedule/utils/validate';
import styles from './edit.module.scss';
const weekdays = moment.weekdays();
export function Edit({ schedule }) {
    const { intervalsErrors, setters: { setIntervalsErrors, setSchedule }, } = useMigrateOpeningHoursContext();
    const handleValidateInterval = useCallback((dayIndex) => (intervals) => void setIntervalsErrors(validateIntervals({
        intervals,
        dayIndex,
        errors: intervalsErrors,
    })), [intervalsErrors, setIntervalsErrors]);
    const handleOpeningHourChange = useCallback((id) => (intervals) => setSchedule(produce((schedule) => {
        const index = schedule.findIndex(({ date: scheduleDate }) => scheduleDate === id);
        schedule[index].intervals = [...intervals];
    })), [setSchedule]);
    return (_jsx(ListItemContext.Provider, Object.assign({ value: {
            intervalsSelectProps: {
                errors: intervalsErrors,
                onChange: handleOpeningHourChange,
                validate: handleValidateInterval,
            },
            onAudioMessageChange: (_) => noop,
            onAutoReplyChange: (_) => noop,
            onAutoReplyClear: (_) => noop,
            onDelete: (_) => noop,
            onOverriddenChange: noop,
        } }, { children: _jsx(FlexBox, Object.assign({ flexDirection: "column", gap: "250" }, { children: schedule.map((schedule, index) => (_jsx(OpeningHours, { className: styles.openingHours, index: index, openingHours: {
                    id: schedule.date,
                    created_at: '',
                    created_by: '',
                    duration: 1,
                    intervals: schedule.intervals,
                    name: weekdays[new Date(schedule.date).getDay()],
                    opening_hour_type: 'regular',
                    recurring: null,
                    start_date: schedule.date,
                }, itemClassName: styles.openingHoursItem }, schedule.date))) })) })));
}
